import noop from 'lodash/noop';
import { srcLight as projectWithSharedConfigurationIconNew } from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/other/components/shared-folder';
import projectWithSharedConfigurationIconOld from '../assets/project-with-shared-configuration-icon.svg';
import type { Template } from '../model/types';

export const PROJECT_NAME_MUST_HAVE_ONE_VALIDATION_ERROR =
	'PROJECT_NAME_MUST_HAVE_ONE_VALIDATION_ERROR' as const;
export const PROJECT_NAME_ALREADY_EXISTS_VALIDATION_ERROR =
	'PROJECT_NAME_ALREADY_EXISTS_VALIDATION_ERROR' as const;
export const PROJECT_NAME_TOO_LONG_VALIDATION_ERROR =
	'PROJECT_NAME_TOO_LONG_VALIDATION_ERROR' as const;
export const PROJECT_NAME_TOO_SHORT_VALIDATION_ERROR =
	'PROJECT_NAME_TOO_SHORT_VALIDATION_ERROR' as const;

export const AGILITY_SCRUM = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum' as const;
export const AGILITY_KANBAN = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban' as const;
export const CLASSIC_KANBAN = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic' as const;
export const CLASSIC_SCRUM = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic' as const;

export type NameValidationError =
	| typeof PROJECT_NAME_MUST_HAVE_ONE_VALIDATION_ERROR
	| typeof PROJECT_NAME_ALREADY_EXISTS_VALIDATION_ERROR
	| typeof PROJECT_NAME_TOO_LONG_VALIDATION_ERROR
	| typeof PROJECT_NAME_TOO_SHORT_VALIDATION_ERROR;

export const FlagType = {
	PROJECT_CREATION_FAILURE: 'PROJECT_CREATION_FAILURE_FLAG',
} as const;

export const TEMPLATE_RECOMMENDED = 'TEMPLATE_RECOMMENDED';
export const TEMPLATE_USER_CHOSEN = 'TEMPLATE_USER_CHOSEN';

export const ScreenType = {
	FORM: 'FORM' as const,
	FORM_WITH_PROJECT_TYPE_DROPDOWN: 'FORM_WITH_PROJECT_TYPE_DROPDOWN' as const,
	ERROR_PAGE: 'ERROR_PAGE' as const,
	EXPERIENCE_SELECTION: 'EXPERIENCE_SELECTION' as const,
	CONTAINER_LINKING: 'CONTAINER_LINKING' as const,
	NEW_TEMPLATE_CHOICE: 'NEW_TEMPLATE_CHOICE' as const,
} as const;

export type ScreenTypes = (typeof ScreenType)[keyof typeof ScreenType];

export const PROJECT_SHARED_CONFIG_KEY = 'PROJECT_SHARED_CONFIG_KEY' as const;
export const PROJECT_SHARED_CONFIG_NAME = 'PROJECT_SHARED_CONFIG_NAME' as const;
export const PROJECT_SHARED_CONFIG_DESCRIPTION = 'PROJECT_SHARED_CONFIG_DESCRIPTION' as const;

export const projectWithSharedConfigurationTemplateNew: Template = {
	key: PROJECT_SHARED_CONFIG_KEY,
	name: PROJECT_SHARED_CONFIG_NAME,
	description: PROJECT_SHARED_CONFIG_DESCRIPTION,
	iconUrl: projectWithSharedConfigurationIconNew,
	// @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type '"business" | "software" | "service_desk" | "product_discovery"'.
	projectTypeKey: undefined,
	infoPages: [],
	features: undefined,
	simplified: false,
};

export const projectWithSharedConfigurationTemplateOld: Template = {
	key: PROJECT_SHARED_CONFIG_KEY,
	name: PROJECT_SHARED_CONFIG_NAME,
	description: PROJECT_SHARED_CONFIG_DESCRIPTION,
	iconUrl: projectWithSharedConfigurationIconOld,
	// @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type '"business" | "software" | "service_desk" | "product_discovery"'.
	projectTypeKey: undefined,
	infoPages: [],
	features: undefined,
	simplified: false,
};
export const CONTAINER_LINKING_ENTITY_PROPERTY_KEY = 'DevopsContainerLinkingDefaultPreference';

export const CONTAINER_LINKING_TARGET_ID = 'create-project-container-linking';

export const TEAM_NAME = 'helix';

// Analytics events
export const BACK_TO_PROJECT_TYPES = 'backToProjectTypes';
export const BACK_TO_PROJECT_TEMPLATES = 'backToProjectTemplates';
export const CHANGE_TEMPLATE = 'changeTemplate';
export const CHANGE_PROJECT_TYPE = 'changeProjectType';
export const VIEW_TEMPLATE_OVERVIEW = 'viewTemplateOverview';
export const CREATE_PROJECT_SOURCE_NAME = 'createProject';

export const defaultProps = {
	isImportProjectOpenInitially: false,
	isTemplatePickerOpenInitially: false,
	isNextGen: false,
	isJswOnboarding: false,
	isOnboarding: false,
	isConnectedProjectScenario: false,
	isJiraCoreOnboarding: false,
	skipTemplateSelection: false,
	recommendedTemplate: undefined,
	defaultSelectedTemplateKey: '',
	source: '',
	showExperienceSelection: false,
	selectedProjectType: null,
	recommendationSessionId: undefined,
	onScreenChange: noop,
	onPermissionsFetched: noop,
	onDrawerClose: noop,
	setOnCloseCallback: noop,
	onCreateStarted: noop,
	isBusinessUser: false,
} as const;

export const DEFAULT_ONBOARDING_PROJECT_KEY = 'FIRST';
export const DEFAULT_ONBOARDING_PROJECT_NAME = 'My first project';
